import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ProjectsComponent} from './projects.component';
import {ProjectCreateEditComponent} from './project-create-edit/project-create-edit.component';
import {ProjectsListComponent} from './projects-list/projects-list.component';
import {ProjectViewComponent} from './project-view/project-view.component';
import {StageViewComponent} from './stage-view/stage-view.component';
import {StageEditComponent} from './stage-edit/stage-edit.component';
import {TaskViewComponent} from './task-view/task-view.component';
import {TaskEditComponent} from './task-edit/task-edit.component';
import {UserRolesGuard} from '../auth/_services/user-roles.guard';
import {AuthGuard} from '../auth/_services/auth.guard';

const projectsRoutes: Routes = [
    {
        path: '',
        component: ProjectsComponent,
        children: [
            {
                path: 'list',
                component: ProjectsListComponent
            },
            {
                path: 'add',
                canActivate: [AuthGuard, UserRolesGuard],
                data: {
                    allowedRoles: ['ROLE_super_admin', 'ROLE_admin', 'ROLE_ProjectsFull']
                },
                component: ProjectCreateEditComponent
            },
            {
                path: 'edit/:id',
                canActivate: [AuthGuard, UserRolesGuard],
                data: {
                    allowedRoles: ['ROLE_super_admin', 'ROLE_admin', 'ROLE_ProjectsFull']
                },
                component: ProjectCreateEditComponent
            },
            {
                path: ':id',
                component: ProjectViewComponent
            },
            {
                path: ':id/stage/:position/view',
                component: StageViewComponent
            },
            {
                path: ':id/stage/:position/edit',
                canActivate: [AuthGuard, UserRolesGuard],
                data: {
                    allowedRoles: ['ROLE_super_admin', 'ROLE_admin', 'ROLE_ProjectsFull']
                },
                component: StageEditComponent
            },
            {
                path: ':id/stage/:position/view/:task/view',
                component: TaskViewComponent
            },
            {
                path: ':id/:task/view',
                component: TaskViewComponent
            },
            {
                path: ':id/stage/:position/view/:task/edit',
                canActivate: [AuthGuard, UserRolesGuard],
                data: {
                    allowedRoles: ['ROLE_super_admin', 'ROLE_admin', 'ROLE_ProjectsFull']
                },
                component: TaskEditComponent
            },
            {
                path: ':id/:task/edit',
                canActivate: [AuthGuard, UserRolesGuard],
                data: {
                    allowedRoles: ['ROLE_super_admin', 'ROLE_admin', 'ROLE_ProjectsFull']
                },
                component: TaskEditComponent
            },
            {path: '', redirectTo: 'list', pathMatch: 'full'},
            {path: '**', redirectTo: 'list', pathMatch: 'full'},
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(projectsRoutes)],
    exports: [RouterModule],
})
export class ProjectsRoutingModule {
}
